var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "57px",
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "savebutton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D08C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6B8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SME_Asia_B2C_Desktop_save",
    transform: "translate(-692.000000, -318.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "savebutton",
    transform: "translate(692.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "saveicon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,3.55271707e-15 L9.5,14.2500199 C9.5,15.1244703 10.2088777,15.8333525 11.0833282,15.8333525 L11.0833282,15.8333525 L36.4166497,15.8333525 C37.2911002,15.8333525 37.9999823,15.1244703 37.9999823,14.2500199 L37.9999823,14.2500199 L37.9999823,3.55271707e-15 L42.7499801,3.55271707e-15 C43.1708347,-0.0024067012 43.5753416,0.162814442 43.8741463,0.459192952 L43.8741463,0.459192952 L56.540807,13.1258537 C56.8371856,13.4246584 57.0024067,13.8291653 57,14.2500199 L57,14.2500199 L57,49.083337 C57,53.4555893 53.4555628,57 49.0833105,57 L49.0833105,57 L47.4999779,57 L47.4999779,26.9166807 C47.4999779,26.0422302 46.7910958,25.3333481 45.9166453,25.3333481 L45.9166453,25.3333481 L11.0833282,25.3333481 C10.2088777,25.3333481 9.5,26.0422302 9.5,26.9166807 L9.5,26.9166807 L9.5,57 L7.91666299,57 C3.54441075,57 0,53.4555893 0,49.083337 L0,49.083337 L0,7.91668949 C0,3.54443725 3.54441075,3.55271707e-15 7.91666299,3.55271707e-15 L7.91666299,3.55271707e-15 L9.5,3.55271707e-15 Z M44,28 L44,56 L13,56 L13,28 L44,28 Z M36.25,43.5555556 L20.75,43.5555556 C19.8939586,43.5555556 19.2,44.2520015 19.2,45.1111111 C19.2,45.9702207 19.8939586,46.6666667 20.75,46.6666667 L20.75,46.6666667 L36.25,46.6666667 C37.1060414,46.6666667 37.8,45.9702207 37.8,45.1111111 C37.8,44.2520015 37.1060414,43.5555556 36.25,43.5555556 L36.25,43.5555556 Z M36.25,34.2222222 L20.75,34.2222222 C19.8939586,34.2222222 19.2,34.9186682 19.2,35.7777778 C19.2,36.6368874 19.8939586,37.3333333 20.75,37.3333333 L20.75,37.3333333 L36.25,37.3333333 C37.1060414,37.3333333 37.8,36.6368874 37.8,35.7777778 C37.8,34.9186682 37.1060414,34.2222222 36.25,34.2222222 L36.25,34.2222222 Z M35,2.66453865e-15 L35,13 L13,13 L13,2.66453865e-15 L35,2.66453865e-15 Z",
    id: "Combined-Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveButton);
export default __webpack_public_path__ + "static/media/SaveButton.23bb2c8d42802149d2e2945141625488.svg";
export { ForwardRef as ReactComponent };